<script>
  export let text;
  export let icon;
  export let color;
  export let onClick;
</script>

<style>
  div {
    display: flex;
    justify-content: center;
    margin-top: 0px;
    margin-left: 10px;
    margin-right: 10px;
  }

  img {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }

  /* Animations */

  div {
    transition: background-color 0.2s linear 0s, border-color 0.2s linear 0s !important;
  }

  div:hover {
    background-color: var(--secondary) !important;
    border-color: var(--secondary) !important;
  }
</style>

<div
  class="button button-sm button-primary"
  style="background-color: {color}; border-color: {color};"
  on:click={onClick}>
  <img src={icon} alt="Button Icon" />
  {text}
</div>
